export interface LanguageDetail {
  countryCode: string;
  label: string;
  i18nCode: string;
}

export const LANGUAGE_DETAILS: LanguageDetail[] = [
  {
    countryCode: "en-US",
    label: "english",
    i18nCode: "en-US"
  },
  {
    countryCode: "es-ES",
    label: "español",
    i18nCode: "es-ES"
  },
  {
    countryCode: "de-DE",
    label: "deutsch",
    i18nCode: "de-DE"
  },
  {
    countryCode: "fr-FR",
    label: "français",
    i18nCode: "fr-FR"
  },
  {
    countryCode: "ru-RU",
    label: "pусский",
    i18nCode: "ru-RU"
  },
  {
    countryCode: "ar-EG",
    label: "العربية",
    i18nCode: "ar-EG"
  },
  {
    countryCode: "ja-JP",
    label: "日本語",
    i18nCode: "ja-JP"
  },
  {
    countryCode: "zh-HK",
    label: "繁體中文",
    i18nCode: "zh-HK"
  },
  {
    countryCode: "zh-CN",
    label: "简体中文",
    i18nCode: "zh-CN"
  },
  {
    countryCode: "ko-KR",
    label: "한국어",
    i18nCode: "ko-KR"
  },
  {
    countryCode: "th-TH",
    label: "ไทย",
    i18nCode: "th-TH"
  }
];

export function hasCountryCode(array: LanguageDetail[], targetCountryCode: string): boolean {
  return array.some(item => item.countryCode === targetCountryCode);
}
